module.exports = __webpack_public_path__ + "static/teamDashboard-2dcc58e2f1e7401308c3ce20581ecbc3.png";